function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "enabled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    d: "M8.938 13 13.9 8.062 12.833 7l-3.9 3.875-1.766-1.75L6.1 10.188zM10 18a7.8 7.8 0 0 1-3.1-.625A8.037 8.037 0 0 1 2.625 13.1 7.8 7.8 0 0 1 2 10a7.775 7.775 0 0 1 .625-3.115A8.066 8.066 0 0 1 6.9 2.625 7.8 7.8 0 0 1 10 2a7.775 7.775 0 0 1 3.115.625 8.1 8.1 0 0 1 4.26 4.26A7.775 7.775 0 0 1 18 10a7.8 7.8 0 0 1-.625 3.1 8.066 8.066 0 0 1-4.26 4.271A7.775 7.775 0 0 1 10 18z",
    transform: "translate(2 3)",
    style: {
      fill: "#479b5e"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnabled);
export default __webpack_public_path__ + "static/media/enabled.5d6c25e7050b8fc912cd71fc16d1a845.svg";
export { ForwardRef as ReactComponent };